export default __webpack_public_path__ + "static/thumb-landscape-9defc3c48a05bcf81c4b77ef1d850239.jpg";